import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { KeycloakService } from '@shared/services/api';
import { ExtendedMenuItem } from '@shared/models';
import { LABELS } from '@shared/constants';
import maintenanceRoutes from 'app/pages/maintenance/page.routes';

@Component({
	selector: 'app-menu',
	standalone: true,
	imports: [CommonModule, AppMenuitem, RouterModule],
	template: `<ul class="layout-menu">
		@for (item of model; track $index; let i = $index) {
			@if (!item.separator) {
				<li app-menuitem [item]="item" [index]="i" [root]="true"></li>
			} @else {
				<li class="menu-separator"></li>
			}
		}
	</ul> `
})
export class AppMenu implements OnInit {
	model: ExtendedMenuItem[] = [];
	authService = inject(KeycloakService);

	ngOnInit() {
		this.model = [
			{
				items: [
					{ label: 'Dashboard', icon: 'pi pi-fw pi-objects-column', routerLink: ['/dashboard'] }
				]
			},
			{
				items: [
					{
						label: 'Employee Roster',
						icon: 'pi pi-fw pi-users',
						routerLink: ['/employee/list']
					}
				]
			},
			{
				items: [
					{
						label: LABELS.PAYROLL_PROCESSING,
						icon: 'pi pi-fw pi-objects-column',
						routerLink: ['/payroll-processing']
					}
				]
			},
			{
				items: [
					{
						label: LABELS.PAYROLL_REVIEW_AND_APPROVAL,
						icon: 'pi pi-fw pi-objects-column',
						routerLink: ['/payroll-review-approval']
					}
				]
			},
			{
				items: [
					{
						label: LABELS.REPORT,
						icon: 'pi pi-fw pi-objects-column',
						routerLink: ['/report']
					}
				]
			},
			{
				items: [
					{
						label: LABELS.MAINTENANCE,
						icon: 'pi pi-fw pi-objects-column',
						items: maintenanceRoutes
							.map((route) => {
								return {
									label: route.data?.['label'],
									routerLink: [`/maintenance/${route.path}`],
									styleClass: '',
									permissions: route?.data?.['permissions'] ? route?.data!['permissions']?.only : []
								};
							})
							.sort((a, b) => a.label.localeCompare(b.label))
					}
				],
				permissions: maintenanceRoutes.flatMap((route) => route?.data?.['permissions']?.only ?? [])
			},
			{
				items: [
					{
						label: 'Logout',
						icon: 'pi pi-fw pi-sign-out',
						command: () => this.logout()
					}
				]
			}
		];
	}

	logout() {
		this.authService.logout();
	}
}
